import React from 'react'

const BkFlowEditPromoField = (props) => {
	const {
		currentPromoCode,
		handlePromoCode,
		hotelLabels,
		specialCodeError,
		isSpecialCodeAvailable
	} = props

	let baseClassNames = 'bk-flow-edit-stay__promo-code'

	if (process.env.REACT_APP_COMPONENT_EDIT_STAY_RATE_CODE_FORMAT === 'uppercase') {
		baseClassNames = 'bk-flow-edit-stay__promo-code u-text-uppercase'
	}

	return (
		<div className={`bk-flow-edit-stay__promo-field${specialCodeError ? ' error' : ''}${isSpecialCodeAvailable ? ' valid' : ''}`}>
			<label
				className="u-element-hidden"
				htmlFor="promoCode"
				id="promoCodeLabel"
			>
				{ hotelLabels && hotelLabels.promoCode ? hotelLabels.promoCode : 'Promo Code' }
			</label>
			<input
				type="text"
				name="promoCode"
				className={baseClassNames}
				placeholder={ hotelLabels && hotelLabels.promoCode ? hotelLabels.promoCode : 'Promo Code' }
				value={ currentPromoCode }
				onChange={ e => handlePromoCode(e.target.value) }
				aria-labelledby="promoCodeLabel"
			 />
		</div>
	)
}


export default BkFlowEditPromoField


// WEBPACK FOOTER //
// ./src/components/edit/rates/BkFlowEditPromoField.js